import React from 'react';
import { ICountrySelect } from '../../../interfaces';
import {
  CSRF_CONTAINER,
  CSRF_CONTENT,
  CSRF_SELECT,
  CSRF_DEFAULT_OPTION,
  CSRF_CA_OPTION,
  CSRF_GB_OPTION,
  CSRF_US_OPTION,
} from './countrySelectTestIds';
import FieldError from '../Shared/FieldError';

import styles from './CountrySelect.module.css';

const CountrySelect: React.FunctionComponent<ICountrySelect> = ({ fieldState, billingCountry }) => {
  const selectStyles = fieldState.hasError
    ? `${styles.csrfSelect} ${styles.csrfInvalid}`
    : styles.csrfSelect;

  return (
    <label data-testid={CSRF_CONTAINER} htmlFor="country" className={styles.csrfContainer}>
      Country
      <div data-testid={CSRF_CONTENT} className={styles.csrfChevron}>
        <select
          data-testid={CSRF_SELECT}
          id="country"
          placeholder="Country"
          name="country"
          data-recurly="country"
          onChange={fieldState.changeHandler}
          onBlur={fieldState.blurHandler}
          value={billingCountry || fieldState.value}
          className={selectStyles}
        >
          <option data-testid={CSRF_DEFAULT_OPTION} value="">
            Select Country
          </option>
          <option data-testid={CSRF_CA_OPTION} value="CA">
            Canada
          </option>
          <option data-testid={CSRF_GB_OPTION} value="GB">
            United Kingdom
          </option>
          <option data-testid={CSRF_US_OPTION} value="US">
            United States
          </option>
        </select>
      </div>
      {fieldState.hasError && <FieldError errorMsg={fieldState.errorMsg} />}
    </label>
  );
};

export default CountrySelect;
